import type { IconData } from '@stacksjs/iconify-core'

export const friedEggBreakfast: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M34 22c0 5.523-4.477 10-10 10s-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10\"/><path d=\"M28 22a4 4 0 0 0-4-4\"/><path d=\"M24 3C12 3 3 13.81 3 27c0 9.823 6.366 18 14.219 18c2.89 0 5.577-1.078 7.82-2.93c2.544-2.1 5.874-3.036 8.92-3.036c6.098 0 11.041-6.183 11.041-13.81C45 14 37.5 3 24 3\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default friedEggBreakfast
